export default __webpack_public_path__ + "static/media/ins_100_women.b26ec733.jpg";